import React, { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { fmtPKR, fmtDate } from "@/lib/format";
import { verifyCup } from "./verifyCup";

const Row = ({ r }) => {
  const [v, setV] = useState(null);
  const run = async () => {
    const res = await verifyCup(r.server_seed, r.id);
    setV(res.sha === r.commit_hash && res.cup === r.winning_cup ? "ok" : "fail");
  };
  return (
    <div className="py-3 text-sm" data-testid={`cups-hist-${r.round_no}`}>
      <div className="flex items-center justify-between gap-3">
        <div>
          <p className="text-white">#{r.round_no} · {fmtPKR(r.amount)} · picked Cup {r.picked_cup + 1}, ball in Cup {r.winning_cup + 1}</p>
          <p className="text-xs text-gray-500">{fmtDate(r.completed_at)}</p>
        </div>
        <div className="text-end shrink-0">
          <p className={r.status === "won" ? "text-emerald-400 font-bold" : "text-red-400 font-bold"}>
            {r.status === "won" ? `Win +${fmtPKR(r.payout)}` : `-${fmtPKR(r.amount)}`}
          </p>
          <button onClick={run} className="text-xs text-orange-400 hover:text-orange-300 inline-flex items-center gap-1" data-testid={`cups-verify-${r.round_no}`}>
            <ShieldCheck className="w-3.5 h-3.5" />{v === "ok" ? "Verified" : v === "fail" ? "Mismatch" : "Verify"}
          </button>
        </div>
      </div>
    </div>
  );
};

export const CupsHistory = ({ rows }) => (
  <div className="ec-card p-6" data-testid="cups-history">
    <h3 className="font-head text-lg font-semibold text-white mb-3">My Three Cups History</h3>
    {rows.length === 0 ? <p className="text-gray-500 text-sm py-8 text-center">No games played yet.</p> :
      <div className="divide-y divide-white/5 max-h-96 overflow-y-auto">{rows.map((r) => <Row key={r.id} r={r} />)}</div>}
  </div>
);
